import { IFormInputMask } from '../models';

export const VRP_BASE_MASK: IFormInputMask = {
  mask: '00AA10||00AA23||000AAA10||000AAA23||F000AAA',
  prefix: '',
  dropSpecialCharacters: false,
  patterns: {
    A: { pattern: new RegExp('[A-Za-z]') },
    F: {
      pattern: new RegExp(
        '[^ JjGgIiQqАаБбВвГгДдЕеЁёЖжЗзИиЙйКкЛлМмНнОоПпРрСсТтУуФфХхЦцЧчШшЩщЪъЫыЬьЭэЮюЯя0-9^!§$%@#&±*<>()]',
      ),
    },
    0: { pattern: new RegExp('[0-9]') },
    1: { pattern: new RegExp('[0-1]') },

    2: { pattern: new RegExp('[2]') },
    3: { pattern: new RegExp('[0]') },
  },
  specialCharacters: [],
};

export const VRP_MOTORCYCLE_MASK: IFormInputMask = {
  mask: '00AA20',
  prefix: '',
  dropSpecialCharacters: false,
  patterns: {
    A: { pattern: new RegExp('[A-Za-z]') },
    F: {
      pattern: new RegExp(
        '[^ JjGgIiQqАаБбВвГгДдЕеЁёЖжЗзИиЙйКкЛлМмНнОоПпРрСсТтУуФфХхЦцЧчШшЩщЪъЫыЬьЭэЮюЯя0-9^!§$%@#&±*<>()]',
      ),
    },
    0: { pattern: new RegExp('[0-9]') },
    2: { pattern: new RegExp('[0-2]') },
  },
  specialCharacters: [],
};

export const VRP_MASK: IFormInputMask = {
  mask: '000AAA20||F000AAA',
  prefix: '',
  dropSpecialCharacters: false,
  patterns: {
    A: { pattern: new RegExp('[A-Za-z]') },
    F: {
      pattern: new RegExp(
        '[^ JjGgIiQqАаБбВвГгДдЕеЁёЖжЗзИиЙйКкЛлМмНнОоПпРрСсТтУуФфХхЦцЧчШшЩщЪъЫыЬьЭэЮюЯя0-9^!§$%@#&±*<>()]',
      ),
    },
    0: { pattern: new RegExp('[0-9]') },
    2: { pattern: new RegExp('[0-2]') },
  },
  specialCharacters: [],
};

export const TEXT_MASK: IFormInputMask = {
  mask: 'T*',
  prefix: '',
  specialCharacters: ['@', '.', '-', '+', '_', '%'],
  dropSpecialCharacters: false,
  patterns: {
    T: { pattern: new RegExp(/./s) },
  },
};

export const DATE_TIME_MASK: IFormInputMask = {
  mask: 'd0.M0.0000 Hh:m0',
  showMaskTyped: true,
  keepCharacterPositions: true,
  errorText: 'form.error.dateFormat',
};

export const DATE_MASK: IFormInputMask = {
  mask: 'd0.M0.0000',
  showMaskTyped: true,
  keepCharacterPositions: true,
  errorText: 'form.error.dateFormat',
};

export const TIME_MASK: IFormInputMask = {
  mask: 'Hh:m0',
  showMaskTyped: true,
  keepCharacterPositions: true,
  errorText: 'form.error.dateFormat',
};

export const EMAIL_MASK: IFormInputMask = {
  mask: 'P*@M*.K*',
  prefix: '',
  specialCharacters: ['@', '.', '-', '+', '_', '%'],
  dropSpecialCharacters: false,
  errorText: 'form.error.email',
  patterns: {
    P: { pattern: new RegExp('[a-zA-Z0-9._%+-]') },
    M: { pattern: new RegExp('[a-zA-Z0-9-]') },
    K: { pattern: new RegExp('[a-zA-Z]') },
  },
};

export const PHONE_NUMBER_MASK: IFormInputMask = {
  mask: '+0 (000) 000 0000',
  prefix: '',
  specialCharacters: ['(', ')', ' ', '+'],
  dropSpecialCharacters: false,
  errorText: 'form.error.phoneNumber',
};

export const LOGIN_MASK: IFormInputMask = {
  mask: 'A*',
  prefix: '',
  specialCharacters: [],
  dropSpecialCharacters: false,
  errorText: 'form.error.login',
  patterns: {
    A: {
      pattern: new RegExp('^[^\u0400-\u04FF!#$%^&*()+=:;?\\|{}\'"<>/,\\[\\]]+$'),
    },
  },
};

export const PASSWORD_MASK: IFormInputMask = {
  mask: 'A*',
  prefix: '',
  specialCharacters: [],
  dropSpecialCharacters: false,
  errorText: 'form.error.login',
  patterns: {
    A: { pattern: new RegExp('^[^\u0400-\u04FF]+$') },
  },
};

export const IIN_MASK: IFormInputMask = {
  mask: '000000000000',
  prefix: '',
  dropSpecialCharacters: false,
  specialCharacters: [],
  errorText: 'form.error.iin',
};

export const BIN_MASK: IFormInputMask = {
  mask: '000000000000',
  prefix: '',
  dropSpecialCharacters: false,
  specialCharacters: [],
  errorText: 'form.error.bin',
};

export const KBE_MASK: IFormInputMask = {
  mask: '00',
  prefix: '',
  dropSpecialCharacters: false,
  specialCharacters: [],
};

export const BIK_MASK: IFormInputMask = {
  mask: 'AAAAAAAA',
  prefix: '',
  dropSpecialCharacters: false,
  specialCharacters: [],
};

export const IIK_MASK: IFormInputMask = {
  mask: 'AAAAAAAAAAAAAAAAAA',
  prefix: 'KZ',
  dropSpecialCharacters: false,
  specialCharacters: [],
};

export const PHONE_EIGHT_NUMBER_MASK: IFormInputMask = {
  mask: '(000) 000 0000',
  prefix: '8',
  dropSpecialCharacters: false,
  specialCharacters: ['(', ')', ' '],
}

export const ZERO_TO_HUNDRED_MASK: IFormInputMask = {
  mask: '099',
  prefix: '',
  dropSpecialCharacters: false,
  specialCharacters: [],
  errorText: 'mask.zeroToHundred',
};

export const ONLY_NUMBERS_MASK: IFormInputMask = {
  mask: '0*',
  errorText: 'mask.onlyNumber',
};

export const PRICE_MASK: IFormInputMask = {
  mask: 'separator.0',
  errorText: 'mask.onlyNumber',
  thousandSeparator: ' ',
  formatter: value => value.replace(' ', ''),
};

export const WEBSITE_MASK: IFormInputMask = {
  mask: 'P*',
  prefix: '',
  specialCharacters: [],
  dropSpecialCharacters: false,
  errorText: 'form.error.website',
  patterns: {
    P: { pattern: new RegExp('^[^\\s]*$') },
  },
};

export const DECIMAL_MASK: IFormInputMask = {
  mask: 'separator.2',
  prefix: '',
  specialCharacters: [',', '.'],
  dropSpecialCharacters: false,
  errorText: 'mask.decimal',
};

export const NEWSLETTER_MASK: IFormInputMask = {
  mask: 'A*',
  prefix: '',
  specialCharacters: [],
  dropSpecialCharacters: false,
  errorText: 'form.error.newsletter',
  patterns: {
    A: { pattern: new RegExp('^.{0,10}$') }, // Разрешаем ввод от 0 до 70 символов
  },
};

export const ONLY_LETTERS_MASK: IFormInputMask = {
  mask: 'A*',
  prefix: '',
  specialCharacters: [],
  dropSpecialCharacters: false,
  errorText: 'Поле должно содержать только буквы',
  patterns: {
    A: { pattern: new RegExp('[a-zA-Zа-яА-ЯёЁ]') },
  },
};

export const PAYMENT_CARD_MASK: IFormInputMask = {
  mask: '0000 0000 0000 0000',
  prefix: '',
  specialCharacters: [' '],
  dropSpecialCharacters: false,
};

export const PAYMENT_EXPIRY_MASK: IFormInputMask = {
  mask: '00/00',
  prefix: '',
  specialCharacters: ['/'],
  dropSpecialCharacters: false,
};

export const PAYMENT_CVV_MASK: IFormInputMask = {
  mask: '000',
  prefix: '',
  specialCharacters: [],
  dropSpecialCharacters: false,
};
